import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";

export const getProductFinalTreatmentOwnList = ({
  productId,
  category,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/final-treatment-own-product",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data
          .filter((data) => data.category === category)
          .map((data) => {
            data.is_disassembly = data.is_disassembly ? "Yes" : "No";
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const addFinalTreatmentOwnToProduct = ({
  productId,
  category,
  end_of_life_strategy,
  percentage_fu_treated,
  treatment_country,
  product_component,
  is_disassembly,
  component_num_fu,
  product_name,
  product_code,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    category: category,
    end_of_life_strategy: end_of_life_strategy,
    percentage_fu_treated: percentage_fu_treated,
    treatment_country: treatment_country || null,
    product_component: product_component || null,
    is_disassembly: is_disassembly,
    component_num_fu: component_num_fu || null,
    product_name: product_name || null,
    product_code: product_code || null,
  });

  var config = {
    method: "post",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/final-treatment-own-product",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
        setErrorMessage(error.response.data);
      }
    });
};

export const getProductFinalTreatmentOwn = ({
  id,
  setObjects,
  objects,
  componentId,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      id +
      "/final-treatment-own-product/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((component) => {
          if (component.id === componentId) {
            const newComponent = response.data.data;
            newComponent.is_disassembly = newComponent.is_disassembly
              ? "Yes"
              : "No";
            return newComponent;
          }
          return component;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateProductFinalTreatmentOwn = ({
  productId,
  componentId,
  category,
  end_of_life_strategy,
  percentage_fu_treated,
  treatment_country,
  product_component,
  is_disassembly,
  component_num_fu,
  product_name,
  product_code,
  objects,
  setObjects = function () {
    return;
  },
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    category: category,
    end_of_life_strategy: end_of_life_strategy,
    percentage_fu_treated: percentage_fu_treated,
    treatment_country: treatment_country || null,
    product_component: product_component || null,
    is_disassembly: is_disassembly,
    component_num_fu: component_num_fu || null,
    product_name: product_name || null,
    product_code: product_code || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/final-treatment-own-product/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.is_disassembly = response.data.data
              .is_disassembly
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      setErrorMessage(error.response.data);
    });
};

export const deleteProductFinalTreatmentOwn = ({
  productId,
  componentId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/final-treatment-own-product/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};
